const middleware = {}

middleware['postcards-redirect'] = require('../middleware/postcards-redirect.js')
middleware['postcards-redirect'] = middleware['postcards-redirect'].default || middleware['postcards-redirect']

middleware['sidebar'] = require('../middleware/sidebar.js')
middleware['sidebar'] = middleware['sidebar'].default || middleware['sidebar']

export default middleware
